/**
 * input directives used for displaying mobile specific inputs
 * a label appears over the input and when the user focuses on the input the label goes above the input
 */
var skSelected = 'sk-selected';
var skInactive = 'inactive';
// text input
bookingApp.directive('skText',function(){
    return {
        link: function(scope, element, attrs, controller){
            var textElement = element.find('input[type=text]');
            var label = element.find('label');
            if(attrs.skText === 'static'){
                label.addClass(skSelected);
                element.addClass(skSelected);
            }
            // setup focus event
            textElement.on('focus',function(){
                // add classes
                textElement.addClass(skSelected);
                label.addClass(skSelected);
                element.addClass(skSelected);
                // remove inactive class to show highlighting
                element.removeClass(skInactive);
            });
            textElement.on('click',function(){
                // add classes
                textElement.addClass(skSelected);
                label.addClass(skSelected);
                element.addClass(skSelected);
                element.removeClass(skInactive);
            });
            textElement.on('blur',function(){
                textElement.removeClass(skSelected);
                element.addClass(skInactive);
                // check that input has value
                if(attrs.skText !== 'static') {
                    if (!textElement.val().length > 0) {
                        label.removeClass(skSelected);
                        element.removeClass(skSelected);
                    }
                }
            });
        }
    }
});
// password field
bookingApp.directive('skPassword',function(){
    return {
        link: function(scope, element, attrs, controller){
            var textElement = element.find('input[type=password]');
            var label = element.find('label');
            if(attrs.skText === 'static'){
                label.addClass(skSelected);
                element.addClass(skSelected);
            }
            // setup focus event
            textElement.on('focus',function(){
                // add classes
                textElement.addClass(skSelected);
                label.addClass(skSelected);
                element.addClass(skSelected);
                // remove inactive class to show highlighting
                element.removeClass(skInactive);
            });
            textElement.on('click',function(){
                // add classes
                textElement.addClass(skSelected);
                label.addClass(skSelected);
                element.addClass(skSelected);
                element.removeClass(skInactive);
            });
            textElement.on('blur',function(){
                textElement.removeClass(skSelected);
                element.addClass(skInactive);
                // check that input has value
                if(attrs.skText !== 'static') {
                    if (!textElement.val().length > 0) {
                        label.removeClass(skSelected);
                        element.removeClass(skSelected);
                    }
                }
            });
        }
    }
});
// number input
bookingApp.directive('skNumber',function($location){
    return {
        link: function(scope, element, attrs, controller){
            var numberElement = element.find('input[type=number]');
            var label = element.find('label');
            if(attrs.skNumber === 'static'){
                label.addClass(skSelected);
                element.addClass(skSelected);
            }
            // setup focus event
            numberElement.on('focus', function(){
                element.addClass(skSelected);
                //numberElement.addClass(skSelected);
                //label.addClass(skSelected);
            });
            scope.$watch('$location.path()', function(locationPath){
                if(!(numberElement.val() > 0)){
                    numberElement.val('');
                } else {
                    if((numberElement.val() >= 1)) {
                        //label.addClass(skSelected);
                    }
                }
            });
            numberElement.on('change',function(){
                if(!(numberElement.val() > 0)){
                    numberElement.val('');
                }
            });
            numberElement.on('blur',function(){
                //numberElement.removeClass(skSelected);
                if (!(numberElement.val() > 0)) {
                    numberElement.val('');
                    if(attrs.skNumber !== 'static'){
                        element.removeClass(skSelected);
                    }
                }
                // check that input has a value
                if(attrs.skNumber !== 'static') {
                    if (!(numberElement.val() > 0)) {
                        numberElement.val('');
                        label.removeClass(skSelected);
                    }
                }
                label.removeClass(skSelected);
            });
        }
    }
});
// date input
bookingApp.directive('skDate', function(){
    return {
        scope: {
            model : '=?',
            safeApply: '=?'
        },
        link: function(scope, element, attrs, controller){
            var dateElement = $(element).find('input[type=date]');
            if(!(typeof scope.model === 'undefined') && !(typeof scope.safeApply === 'undefined')) {
                dateElement.on('blur change', function () {
                    scope.model = moment(dateElement.val()).toDate();
                    scope.safeApply();
                });
            }
            //var dateElement = element.find('input[type=date]');
            //var label = element.find('label');
            var label = $(element).find('label');
            if(attrs.skDate === 'static'){
                element.addClass(skSelected);
            } else {
                if(dateElement.val()){
                    element.addClass(skSelected);
                }
                scope.$watch(function(){return dateElement.val()}, function () {
                    if(dateElement.val()){
                        element.addClass(skSelected);
                    }
                });
            }
            // define event handler logic
            var setup = function(){
                //element.addClass(skSelected);
                //dateElement.addClass(skSelected);
                //label.addClass(skSelected);
            };
            var reset = function(){
                // check if the date is static, then check the value before styling
                if(attrs.skDate !== 'static'){
                    if(dateElement.val()){
                        element.addClass(skSelected);
                    } else {
                        element.removeClass(skSelected);
                    }
                }
            };
             //setup focus event handlers
            dateElement.on('focus', setup);
            dateElement.on('click', setup);
            // setup defocus event handlers
            $(dateElement).on('blur', reset);
            //dateElement.on('blur',reset);
            $(dateElement).on('change', reset);
            //dateElement.on('change',reset);
        }
    }
});
// select input
bookingApp.directive('skSelect',function(){
    return {
        scope: {
            isMulti: '=?',
            customField: '=?'
        },
        link: function(scope, element, attrs, controller){
            var selectElement = element.find('select');
            var label = element.find('label');
            if(attrs.skSelect === 'static'){
                element.addClass(skSelected);
            }
            // define event handler logic
            var setup = function(){
                element.addClass(skSelected);
                element.removeClass(skInactive);
                //selectElement.addClass(skSelected);
                //label.addClass(skSelected);
            };
            var reset = function(){
                selectElement.removeClass(skSelected);
                element.addClass(skInactive);
                // check the select has a value
                //element.removeClass(skSelected);
                if(attrs.skSelect !== 'static'){
                    //label.removeClass(skSelected);
                }
            };
            // setup focus event handlers
            selectElement.on('focus',setup);
            selectElement.on('click',setup);
            // setup defocus event handlers
            selectElement.on('blur',reset);
            selectElement.on('change',reset);
            selectElement.find('option').on('click',reset);

            if(scope.customField) {
                element.on('change', function () {
                    var selectedOption = $(element).find('select').find('option:selected');
                    if ($(selectedOption).val() === '_empty') {
                        element.removeClass(skSelected);
                    } else {
                        element.addClass(skSelected);
                    }
                });
            }
        }
    }
});
bookingApp.directive('skTextArea', function(){
    return {
        link: function(scope, element, attrs, controller){
            var textarea = element.find('textarea');
            var label = element.find('label');
            // element.addClass(skSelected);
            textarea.on('focus', function(){
                // add classes
                textarea.addClass(skSelected);
                label.addClass(skSelected);
                element.addClass(skSelected);
                // remove inactive class to show highlighting
                element.removeClass(skInactive);
            });
            textarea.on('click', function(){
                // add classes
                textarea.addClass(skSelected);
                label.addClass(skSelected);
                element.addClass(skSelected);
                // remove inactive class to show highlighting
                element.removeClass(skInactive);
            });
            textarea.on('blur', function(){
                textarea.removeClass(skSelected);
                element.addClass(skInactive);
                // check that textarea has value
                if(!textarea.val().length > 0){
                    label.removeClass(skSelected);
                    element.removeClass(skSelected);
                }
            });
        }
    }
});
// currency input
